import { Injectable } from '@angular/core';
import { ViewEditMode } from '@shared/components/most-used/view-edit-switch/view-edit-switch.component';
import { BehaviorSubject, Subject } from 'rxjs';

export interface IUnsavedChangesSupportedComponent {
  // ngOnDestroy: () => void;
  // isFormSaved$: BehaviorSubject<boolean>;
  isFormSaved: () => boolean;
  mode?: ViewEditMode;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangingsService {
  leavePageWithChangesTrigger$ = new Subject<null>();
  userAnswerResult$ = new Subject<boolean>();
  private currentComponent: IUnsavedChangesSupportedComponent;
  // private originalOnDestroy: any;
  // private onDestroyPatchedMarker = '__ngOnDestroyPatchedByUnsavedChangingsService__'

  constructor() {}

  isFormSaved(component?: any) {
    if (component && this.currentComponent && component !== this.currentComponent) {
      // eslint-disable-next-line no-console
      console.error('Passed component not equal current', component, this.currentComponent);
      return true;
    }
    if (!this.currentComponent?.isFormSaved) {
      console.error('Component has no isFormSaved method', this.currentComponent);
      return true;
    }

    return this.currentComponent.isFormSaved();
  }

  triggerShowDialog() {
    this.leavePageWithChangesTrigger$.next();
  }

  registerComponent(component: IUnsavedChangesSupportedComponent) {
    this.currentComponent = component;
  }

  unregisterCurrentComponent() {
    this.currentComponent = null;
  }
}
